<template>
  <div
    class="image-upload-wrapper"
    :class="{
      'has-image': previewImage,
      'no-image': !previewImage,
    }"
    data-test="graphics-assetChanger"
  >
    <template v-if="previewImage">
      <div
        class="chosen-image"
        :style="{
          backgroundImage: 'url(' + previewImage + '?w=200)',
        }"></div>
      <div class="chosen-image-actions">
        <button
          data-balloon="Choose asset"
          data-balloon-pos="up-right"
          class="btn btn-sm btn-icon choose-image"
          data-test="graphics-assetChanger-chooseAsset"
          data-entity="graphics-assetChanger-chooseAsset"
        @click="selectAsset"
      >
        <span :class="assetIcon"></span>
        </button>
        <button
          v-if="allowRemove"
          data-balloon="Remove asset"
          data-balloon-pos="up-right"
          class="btn btn-sm btn-icon remove-image"
          data-test="graphics-assetChanger-removeAsset"
          data-entity="graphics-assetChanger-removeAsset"
          @click="$emit('remove-asset')"
        >
          <span class="fa-solid fa-xmark"></span>
        </button>
      </div>
    </template>

    <template v-else>
      <button
        data-balloon="Choose asset"
        data-balloon-pos="up"
        class="btn btn-style-b btn-sm btn-icon choose-image"
        data-test="graphics-assetChanger-chooseAsset"
        data-entity="graphics-assetChanger-chooseAsset"
        @click="selectAsset"
      >
        <span class="fa-solid fa-plus"></span><span :class="assetIcon"></span>
      </button>
    </template>
  </div>
</template>

<script>
import SettingsMixins from '../../mixins/settings-mixins';

export default {
  emits: ['remove-asset', 'modal', 'select-asset'],
  name: 'AssetChanger',
  components: {
  },
  mixins: [SettingsMixins],
  props: {
    previewImage: {
      type: String,
      required: true,
    },
    assetType: {
      type: String,
      required: true,
    },
    allowRemove: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    assetIcon() {
      switch (this.assetType) {
        case 'video':
          return 'fa-solid fa-video';

        default: // image
          return 'fa-solid fa-image';
      }
    },
  },
  methods: {
    selectAsset() {
      this.$emit('modal', { open: true, type: this.assetType });

      window.assetmanfn = (selected) => {
        this.$emit('select-asset', selected);

        this.$emit('modal', { open: false });
      };
    },
  },
};
</script>
